/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult interface.
 */
export function instanceOfFxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult(value) {
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined)
        return false;
    if (!('GameId' in value) || value['GameId'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResultFromJSON(json) {
    return FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResultFromJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'GameSystemName': json['GameSystemName'],
        'GameId': json['GameId'],
    };
}
export function FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResultToJSON(json) {
    return FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResultToJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'GameSystemName': value['GameSystemName'],
        'GameId': value['GameId'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult.js.map